<script lang="ts">
  import { getContext } from "svelte";
  import { createDropdownMenu } from "@melt-ui/svelte";
  import Button, { type ButtonProps } from "../Button.svelte";

  type Props = Extract<ButtonProps, { as?: "a" }>;

  let { children, class: className, ...rest }: Props = $props();

  const {
    elements: { trigger },
    states: { open },
  } = getContext<ReturnType<typeof createDropdownMenu>>("menu");
</script>

<Button
  meltElement={trigger}
  type="button"
  class={[className, $open && "!bg-alpha-100"]}
  data-state={$open ? "open" : "closed"}
  aria-label="Open menu"
  {...rest}
>
  {@render children?.()}
</Button>
